import React, { useState } from "react";
import Tooltip from "@/tooltip";
import ChartColours from "./ChartColours";
import { roundTo2 } from "../validation/Validators";

const batteryChartStyle = {
	border: "2px solid white",
	borderRadius: "10px",
	height: "2rem",
	overflow: "hidden",
	gap: 2,
	display: "grid",
};

const textStyle = {
	color: "white",
	fontWeight: "bold",
	fontSize: "12px",
	lineHeight: "20px",
	display: "flex",
	alignItems: "center",
	justifyContent: "center",
};

const BatteryChart = ({ columns, total, title, hide, currency }) => {

	const totalWidth = parseFloat(total) || 100;

	const gridTemplateColumns = columns?.reduce((acc, { value }) => {
		const percentage = Math.ceil((parseFloat(value) / totalWidth) * 10);

		const fraction = Math.max(percentage, 1);

		return `${acc} ${fraction}fr`;
	}, "");

	if (!columns?.length)
		return (
			<div>
				{title ? <div className="text-center">{title}</div> : null}
				<div style={{ ...batteryChartStyle, gridTemplateColumns: "1fr" }}>
					<div style={{ background: "#eceff1" }}></div>
				</div>
			</div>
		);

	return (
		<div>
			{title ? <div className="text-center">{title}</div> : null}
			{!hide?.total ? (
				<div className="text-center">
					{currency ?? ""}
					{roundTo2(totalWidth)}
				</div>
			) : null}
			<div style={{ ...batteryChartStyle, gridTemplateColumns }}>
				{columns?.map(({ name, value }, index) => {
					return (
						<Tooltip
							key={index}
							as="div"
							styles={{ background: ChartColours[index], ...textStyle }}
							content={`${name}: ${currency ?? ""}${roundTo2(value)}`}
							arrowSize={5}
						/>
					);
				})}
			</div>
		</div>
	);
};

export default BatteryChart;
